import { array, boolean, enum as enumFactory, lazySchema, number, strictObject, string } from "../../lazy-zod.js";
import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import { connectorConnectionNameSchema, connectorServiceSchema } from "./connector-connections.js";
//#region src/schemas/http/plugin-access.ts
const PLUGIN_ERROR_CODES = [
	"plugin.access_changed",
	"plugin.access_invalid",
	"plugin.access_manage_forbidden",
	"plugin.action_forbidden",
	"plugin.action_unavailable",
	"plugin.caller_forbidden",
	"plugin.catalog_unavailable",
	"plugin.confirmation_invalid",
	"plugin.connection_not_found",
	"plugin.connection_owner_unavailable",
	"plugin.connection_required",
	"plugin.connection_unavailable",
	"plugin.human_required",
	"plugin.identity_unavailable",
	"plugin.operation_identity_unavailable",
	"plugin.operation_unavailable",
	"plugin.personal_request_required",
	"plugin.request_invalid",
	"plugin.request_provenance_unavailable",
	"plugin.runtime_invalid",
	"plugin.runtime_unavailable",
	"plugin.state_unavailable"
];
const pluginConsumerSchema = enumFactory([
	"center_agent",
	"local_agent",
	"remote_agent"
]);
const pluginPermissionSchema = enumFactory([
	"none",
	"read",
	"write"
]);
const pluginAccessPolicySchema = strictObject({
	center_agent: pluginPermissionSchema,
	local_agent: pluginPermissionSchema,
	remote_agent: pluginPermissionSchema
});
const pluginAccessSchema = strictObject({
	canManage: boolean(),
	connectionName: connectorConnectionNameSchema,
	scope: enumFactory(["member", "shared"]),
	policy: pluginAccessPolicySchema,
	revision: number().int().nonnegative()
});
const pluginAccessListResponseSchema = strictObject({
	organizationId: string().trim().min(1),
	connections: array(pluginAccessSchema)
});
const pluginAccessListRpcInputSchema = strictObject({
	context: openMeldRequestContextSchema,
	expectedOrganizationId: string().trim().min(1),
	service: connectorServiceSchema
});
const pluginAccessUpdateBodySchema = strictObject({
	connectionName: connectorConnectionNameSchema,
	expectedRevision: number().int().nonnegative(),
	policy: pluginAccessPolicySchema
});
const pluginAccessUpdateRpcInputSchema = lazySchema(() => pluginAccessListRpcInputSchema.extend({ ...pluginAccessUpdateBodySchema.shape }));
//#endregion
export { PLUGIN_ERROR_CODES, pluginAccessListResponseSchema, pluginAccessListRpcInputSchema, pluginAccessPolicySchema, pluginAccessSchema, pluginAccessUpdateBodySchema, pluginAccessUpdateRpcInputSchema, pluginConsumerSchema, pluginPermissionSchema };

//# sourceMappingURL=plugin-access.js.map